import { render, staticRenderFns } from "./v-order-confirmation-purchase-document.vue?vue&type=template&id=526c22cc&scoped=true"
import script from "./v-order-confirmation-purchase-document.vue?vue&type=script&lang=js"
export * from "./v-order-confirmation-purchase-document.vue?vue&type=script&lang=js"
import style0 from "./v-order-confirmation-purchase-document.vue?vue&type=style&index=0&id=526c22cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526c22cc",
  null
  
)

export default component.exports